import { Expansion } from '../../../shared/gameConfig/expansion';
import { isExpansionFeatureAllowed, isRaidFeatureAllowed, isSeasonFeatureAllowed } from './expansionFeatureAccess';

export const MIN_COMBAT_LOG_DOWNLOAD_EXPANSION = Expansion.Midnight;

export function isCombatLogDownloadExpansionAllowed(expansionId: number | null | undefined) {
  return isExpansionFeatureAllowed(expansionId, MIN_COMBAT_LOG_DOWNLOAD_EXPANSION);
}

export function isCombatLogDownloadRaidAllowed(raidSlug: string | null | undefined) {
  return isRaidFeatureAllowed(raidSlug, MIN_COMBAT_LOG_DOWNLOAD_EXPANSION);
}

export function isCombatLogDownloadSeasonAllowed(seasonSlug: string | null | undefined) {
  return isSeasonFeatureAllowed(seasonSlug, MIN_COMBAT_LOG_DOWNLOAD_EXPANSION);
}
